import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyTruelarkLogo = lazy(() => import('./svg-components/truelark-logo'));

const TruelarkLogo = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyTruelarkLogo {...rest} />
  </Suspense>
);

export default TruelarkLogo;
